module.exports = __webpack_public_path__ + "img/BOR_med-school.fe1f77f4.webp";